export default __webpack_public_path__ + "static/media/colorboxes.7934e08d.PNG";